(() => {
  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-nk-cookie-preferences]');
    if (!button || button.disabled) return;
    const status = button.parentElement.querySelector('[data-nk-cookie-preferences-status]');
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    status.hidden = true;
    try {
      for (let attempt = 0; attempt < 30 && !window.privacyBanner?.showPreferences; attempt++) {
        await new Promise((resolve) => setTimeout(resolve, 100));
      }
      if (!window.privacyBanner?.showPreferences) throw new Error('Privacy banner unavailable');
      await window.privacyBanner.showPreferences();
    } catch {
      status.textContent = status.dataset.error;
      status.hidden = false;
    } finally {
      button.disabled = false;
      button.removeAttribute('aria-busy');
    }
  });
})();
